import { z } from 'zod';

const ignoreEmpty = (arg: unknown) => (arg === '' ? undefined : arg);

export const EnvSchema = z
  .object({
    baseUrl: z.preprocess(ignoreEmpty, z.string().optional().default('https://api.cognitedata.com')),
    strictMode: z.boolean().optional().default(false),
    appName: z.preprocess(ignoreEmpty, z.string().optional().default('Cognite Dashboard')),
    auth: z
      .object({
        clientId: z.preprocess(ignoreEmpty, z.string()),
        tenantId: z.preprocess(ignoreEmpty, z.string()),
        cluster: z.preprocess(ignoreEmpty, z.string()),
        project: z.preprocess(ignoreEmpty, z.string()),
        redirectUri: z.preprocess(ignoreEmpty, z.string().optional().default(document.location.origin)),
      })
      .strict(),
    cdf: z
      .object({
        url: z.preprocess(ignoreEmpty, z.string().optional()),
      })
      .strict(),
    dataModelSpace: z.preprocess(ignoreEmpty, z.string().optional().default('default')),
    dataInstanceSpace: z.preprocess(ignoreEmpty, z.string().optional().default('default')),
    dataModelVersion: z.preprocess(ignoreEmpty, z.string().optional().default('v1')),
    dataModelExternalId: z.preprocess(ignoreEmpty, z.string().optional().default('default')),
  })
  .strict();

export type EnvSchema = z.infer<typeof EnvSchema>;
